import axios from 'axios';
import { ICuotaSocietaria } from '@/shared/model/cuota-societaria.model';

const baseApiUrl = 'api/cuota-societarias';

export default class CuotaSocietariaService {
  public findAll(): Promise<ICuotaSocietaria[]> {
    return new Promise<ICuotaSocietaria[]>((resolve, reject) => {
      axios.get(baseApiUrl).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public create(entity: ICuotaSocietaria): Promise<ICuotaSocietaria> {
    return new Promise<ICuotaSocietaria>((resolve, reject) => {
      axios.post(baseApiUrl, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public update(entity: ICuotaSocietaria): Promise<ICuotaSocietaria> {
    return new Promise<ICuotaSocietaria>((resolve, reject) => {
      axios.put(`${baseApiUrl}/${entity.id}`, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios.delete(`${baseApiUrl}/${id}`).then(res => resolve(res)).catch(err => reject(err));
    });
  }
}
